import React from "react";
import { FaPen, FaEllipsisV } from "react-icons/fa";
import { Device } from "..";
import i18n from "../../i18n/locales/config";
import { useTranslation } from "react-i18next";

const DeviceInfo = ({ device }) => {
  const { t } = useTranslation();
  // console.log(device)
  return (
    <div className="text-right">
      <div>
        <i className="circleTop icon-plug text-center m-auto"></i>
        <div className="text-center mt-2">
          <p className="m-0">{t("اطلاعات دستگاه")}</p>
        </div>
      </div>
      <div className="my-4">
        <div
          className="widgetInfo bg-white p-3 mb-3"
          style={{ height: "30vh" }}
        >
          <img src={device.category.image} className="w-100 h-100" />
        </div>
        <div className="widgetInfo bg-white p-3 mb-3 d-flex justify-content-between align-items-center">
          <div>
            <p className="fn12 text-muted">{t("نام دستگاه")} </p>
            <p className="fn12 m-0">{device.caption}</p>
          </div>
          <span
            className="editNameDevice d-flex align-items-center justify-content-center rounded-circle"
            style={{ color: "#4B80E3", fontSize: "18px" }}
          >
            <FaPen />
          </span>
        </div>
        <div className="widgetInfo bg-white p-3 mb-3">
          <div>
            <p className="fn12 text-muted">{t("نام شرکتی دستگاه")}</p>
            <p className="fn12">{device.category.mark}</p>
          </div>
          <div>
            <p className="fn12 text-muted">{t("دسته بندی دستگاه")}</p>
            <p className="fn12">test</p>
          </div>
          <div>
            <p className="fn12 text-muted">{t("سریال دستگاه")}</p>
            <p className="fn12">{device.serial}</p>
          </div>
          <div>
            <p className="fn12 text-muted">{t("تعداد ویجت افزوده شده")}</p>
            <p className="fn12">test</p>
          </div>
          <div>
            <p className="fn12 text-muted">
              {t("تاریخ افزودن دستگاه به داشبورد")}
            </p>
            <p className="fn12">test</p>
          </div>
          <div>
            <p className="fn12 text-muted">{t("توضیحات دستگاه")}</p>
            <p className="fn12">{device.category.description}</p>
          </div>
          <div
            style={{ borderRadius: "8px" }}
            className="bg-priimary text-white text-center py-3 fn"
          >
            {t("اطلاعات بیشتر")}
          </div>
          <p className="fn12 text-center text-muted mt-2 mx-auto w-75">
            {t("برای مشاهده اطلاعات بیشتر به صفحه محصول در سایت مراجعه نمایید")}
          </p>
        </div>
        <div className="widgetInfo bg-white p-3 mb-3">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <p className="fn12 text-muted m-0">{t("ویجت های دستگاه")}</p>
            <p className="fn12 text-muted m-0">{t("6 ویجت")}</p>
          </div>
          <div
            className="d-flex justify-content-between align-items-center pb-3"
            style={{ borderBottom: "1px solid #EEEEEE" }}
          >
            <div className="d-flex align-items-center">
              <span className="widgetsDevice d-block rounded-circle ml-2"></span>
              <div>
                <p className="fn m-1">{t("ویجت خاموش و روشن")}</p>
                <p className="fn12 text-muted m-0">{t("اسم اصلی ویجت")}</p>
              </div>
            </div>
            <FaEllipsisV />
          </div>
        </div>
      </div>
    </div>
  );
};

export { DeviceInfo };
